module.exports = __webpack_public_path__ + "img/banner-9.6302afac.jpg";